import React from 'react'

export default function Footer() {
 return (
  <footer>
   <p>© 2020 Copyright Manoj Satwase</p>
  </footer>
 )
}
